interface ErrorReason {
	status: number;
	statusText: string;
}

const promiseXHR = (fileUrl: string): Promise<string> => {
	return new Promise((resolve: (value: string) => void, reject: (reason?: ErrorReason) => void) => {
		const xhr = new XMLHttpRequest();
		xhr.open('GET', fileUrl);
		xhr.onload = () => resolve(xhr.response);
		xhr.onerror = () => reject({
			status: xhr.status,
			statusText: xhr.statusText
		});
		xhr.send();
	});
};

const isFileContentTrue = async (fileUrl: string) => {
	try {
		const response = await promiseXHR(fileUrl);
		return response === 'true';
	} catch (error) {
		return false;
	}
};

class AppTypeUtils {
	private static _isMobileAppMainView: boolean;
	private static _isMultiApp: boolean;

	public static async init(): Promise<void> {
		await AppTypeUtils.initIsMobileAppMainview();
		await AppTypeUtils.initIsMultiApp();
	}

	public static get isMobileAppMainView(): boolean {
		if (AppTypeUtils._isMobileAppMainView === undefined) {
			console.error('AppTypeUtils.isMobileAppMainView is called before being initialized by AppTypeUtils.init()');
			return false;
		}

		return AppTypeUtils._isMobileAppMainView;
	}

	public static get isMultiApp(): boolean {
		if (!AppTypeUtils._isMobileAppMainView) {
			return false;
		}

		if (AppTypeUtils._isMultiApp === undefined) {
			console.error('AppTypeUtils.isMultiApp is called before being initialized by AppTypeUtils.init()');
			return false;
		}

		return AppTypeUtils._isMultiApp;
	}

	private static async initIsMobileAppMainview(): Promise<void> {
		AppTypeUtils._isMobileAppMainView = await this.getIsMobileAppMainview();
	}

	private static async initIsMultiApp(): Promise<void> {
		AppTypeUtils._isMultiApp = await this.getIsMultiApp();
	}

	private static async getIsMobileAppMainview(): Promise<boolean> {
		return isFileContentTrue('./.gallery/config/isMobileAppMainView');
	}
	private static async getIsMultiApp(): Promise<boolean> {
		return isFileContentTrue('./.gallery/config/isMultiAppEnabled');
	}
}

export default AppTypeUtils;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/appType.ts